import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(() => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: '400px',
      backgroundColor: 'rgba(254, 235, 238, 1)',
      borderRadius: '8px',
      padding: '24px',
      flexGrow: 1,
      flexShrink: 0,
      gap: '25px',
    },
    title: {
      color: 'rgba(229, 57, 53, 1)',
      fontSize: '16px',
      fontWeight: 700,
    },
    body: {
      display: 'flex',
      flexDirection: 'column',
      fontSize: '12px',
      color: 'rgba(0, 0, 0, 0.6)',
    }
  }
))
